export default __webpack_public_path__ + "media/images/add_hm-e8aa72fb648af45398f7cb45ac5e077d.png";